import {SET_USER} from '../../actions/app/user/user.actions'

export const userReducer = (user = {}, action = {}) => {
    const {payload} = action

    if (action.type === SET_USER) {
        return payload.data
    } else {
        return user
    }
}
